export * from './FraudAccessModal';
export * from './FraudAccessContent';
export * from './FraudAccessStyles';

export const FRAUD_ACCESS_COOKIE = 'fraudAccess';
export const FRAUD_ACCESS_TIME_COOKIE = 'fraudAccessTime';
